import React, { useState, useRef } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  LinearProgress,
  TextField,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Divider,
  useTheme,
  FormControl,
  LoadingButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AdmissionsHero from "../../components/AdmissionsComponents/AdmissionsHero";
import TermsConditions from "../../components/AdmissionsComponents/TermsConditions";
import { useTranslation } from "react-i18next";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client/react";
import {
  GetWebsiteArticles,
  ArticalesById,
} from "../../graphql/articleQueries.js";
import PhoneNumberInput from "../../components/PhoneInput.jsx";
import { GET_ALL_NATIONALITIES } from "../../graphql/nationalitiesQueries.js";
import {
  GET_ALL_COUNTRIES,
  GET_CITIES_BY_COUNTRY_ID,
} from "../../graphql/countriesQueries.js";
import {
  GET_ALL_DEPARTMENTS_IN_FACULTY_BY_ID,
  GET_ALL_FACULITIES,
} from "../../graphql/facultyQuiries.js";
import { CREATE_REGISTERATION_FORM } from "../../graphql/registerationFormQueries.js";
import { CREATE_REGISTERATION_FORM_TRANSACTION, INITIATE_ONLINE_PAYMENT } from "../../graphql/transactionQueries.js";
import notify from "../../components/notify.js";
import { baseURL } from "../../Api/apolloClient.js";
import formatDateToString from "../../components/Utilities/FormatDateToString.js";
import { GET_ACADEMY_TERMS_BY_FACULTY_DEPARTMENT_ID } from "../../graphql/AcademyTerms.js";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingPage from "../../components/LoadingComponent.jsx";
import logger from "../../utils/logger.js";

// CustomTextField wrapper (keeps placeholder support + helperText)
function CustomTextField(props) {
  const theme = useTheme();
  // const { placeholder, helperText, error, ...rest } = props;

  const { placeholder, helperText, error, children, ...rest } = props;
  const { i18n } = useTranslation();
  const isArabic = i18n.language == "ar";

  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      {...rest}
      sx={{
        background: theme.palette.primary?.textField ?? "transparent",
        color: theme.palette.primary?.textFieldText ?? "inherit",
        "& .MuiInputBase-input": {
          color: theme.palette.primary?.textFieldText ?? "inherit",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(0,0,0,0.12)",
        },
        "& .MuiFormHelperText-root": {
          color: "error",
          fontFamily: "Cairo, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.75rem",
          textAlign: isArabic ? "right" : "left",
          marginTop: 0,
          marginBottom: 0,
          marginRight: 0,
          marginLeft: 0,
          background: theme.palette.background.paper, // ✅ نفس لون خلفية الـ paper
        },
        ...props.sx,
      }}
    >
      {children}
    </TextField>
  );
}

export default function Admissions() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromAdmin = searchParams.get('fromAdmin') === 'true';

  const [acceptTerms, setAcceptTerms] = useState(fromAdmin ? true : false);
  const [step, setStep] = useState(1);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  // const[registerationFees,setRegisterationFees] = useState(0);
  const [registerationFeesResults, setRegisterationFeesResults] =
    useState(null);
  const [selectedPaymnetMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const {
    data: ArticalesData,
    loading: ArticalesLoading,
    error: ArticalesError,
  } = useQuery(ArticalesById, {
    variables: { departmentId: "69d4e86acbc5ef33bbd3eada" },
    fetchPolicy: "network-only",
  });
  logger.log("ArticalesData", ArticalesData);
  // get all nationalities
  const {
    data: nationalitiesData,
    loading: nationalitiesLoading,
    error: nationalitiesError,
  } = useQuery(GET_ALL_NATIONALITIES, {
    fetchPolicy: "network-only",
  });

  // get all countries
  const {
    data: countriesData,
    loading: countriesLoading,
    error: countriesError,
  } = useQuery(GET_ALL_COUNTRIES, { fetchPolicy: "network-only" });

  // get cities by country code
  const [
    getCitiesByCountry,
    { data: citiesInCountry, loading: citiesLoading, error: citiesError },
  ] = useLazyQuery(GET_CITIES_BY_COUNTRY_ID, { fetchPolicy: "network-only" });

  // get all faculities
  const {
    data: faculitiesData,
    loading: faculitiesLoading,
    error: faculitiesError,
  } = useQuery(GET_ALL_FACULITIES, { fetchPolicy: "network-only" });

  // get departments in faculty
  const [
    getFacultyDepartmentsByFaculty,
    {
      data: departmentsInFaculty,
      loading: departmentsLoading,
      error: departmentsError,
    },
  ] = useLazyQuery(GET_ALL_DEPARTMENTS_IN_FACULTY_BY_ID, {
    fetchPolicy: "network-only",
  });

  // تجيب الترمات بتاعة القسم
  const [
    getAcademyTermsByFacultyDepartment,
    { data: { getAcademyTermsByFacultyDepartment: termsData } = {}, loading: termsLoading, error: termsError },
  ] = useLazyQuery(GET_ACADEMY_TERMS_BY_FACULTY_DEPARTMENT_ID, {
    fetchPolicy: "network-only",
  });


  // create registeration form
  const [
    createRegisterForm,
    { data: createResponse, loading: createLoading, error: createError },
  ] = useMutation(CREATE_REGISTERATION_FORM);

  // CREATE NEW tRANSACTION
  const [
    createTransaction,
    {
      data: transactionResponse,
      loading: transactionLoading,
      error: transactionError,
    },
  ] = useMutation(CREATE_REGISTERATION_FORM_TRANSACTION);

  const [
    initiateOnlinePayment,
    {
      loading: onlinePaymentLoading,
    },
  ] = useMutation(INITIATE_ONLINE_PAYMENT);


  // step1 state
  const [personal, setPersonal] = useState({
    first_name: "",
    second_name: "",
    third_name: "",
    fourth_name: "",
    // fullName: "",
    gender: "",
    nationality_id: "",
    birthdate: "",
    email: "",
    home_tel: "",
    mobile: "",
    national_id: "",
    national_id_type: "",
  });
  // errors hold message string ('' or message)
  const [errors, setErrors] = useState({});

  // step2 state
  const [academic, setAcademic] = useState({
    education_year: "",
    study_place: "",
    country_id: "",
    city_id: "",
    high_school_student_number: "",
    general_grade: "",
    gpa: "",
    high_school_certificate_file: null,
    academic_record: null,
    is_clearance: false,
    faculty_id: "",
    faculty_department_id: "",
    academyTerm_id: ""
  });
  const [acadErrors, setAcadErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState("");

  const [isUploadingAcademicRecord, setIsUploadingAcademicRecord] = useState(false);
  const [uploadAcademicRecordProgress, setUploadAcademicRecordProgress] = useState(0);
  const [uploadAcademicRecordError, setUploadAcademicRecordError] = useState("");
  const [selectedAcademicRecordFile, setSelectedAcademicRecordFile] = useState(null);

  const fileInputRef = useRef(null);
  const academicRecordInputRef = useRef(null);
  const paymentDocInputRef = useRef(null);
  const [paymentDocumentFile, setPaymentDocumentFile] = useState(null);
  const [isUploadingPaymentDoc, setIsUploadingPaymentDoc] = useState(false);
  const [uploadPaymentDocProgress, setUploadPaymentDocProgress] = useState(0);
  const genders = [
    { value: "male", label: t("admissions.male") },
    { value: "female", label: t("admissions.female") },
  ];

  const paymentMethods = [
    { value: "CASH", label: t("admissions.cash") },
    { value: "BANK_TRANSFER", label: t("admissions.bankTransfer") },
    { value: "ONLINE", label: t("admissions.onlinePayment") },
  ];
  const nationalities = nationalitiesData?.nationalities?.filter(el => el.status);
  const countries = countriesData?.countries ? countriesData?.countries?.filter(el => el?.status) : null;
  const cities = citiesInCountry?.getCitiesByCountry
    ? citiesInCountry?.getCitiesByCountry
    : null;

  // show only active faculties
  const faculties = faculitiesData?.faculties
    ? faculitiesData?.faculties?.filter(el => el.status)
    : null;

  //  // show only active departments
  const departments = departmentsInFaculty?.getFacultyDepartmentsByFaculty
    ? departmentsInFaculty?.getFacultyDepartmentsByFaculty?.filter(el => el.status)
    : null;

  // FIRST term data and active terms
  let firstTermData = termsData?.filter(el => (el.term_number == 1 && el.status));

  logger.log('firstTermData', firstTermData);

  // --- validation helpers (returns message or empty string) ---
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // phone as text: expecting local Saudi like 5XXXXXXXX (9 digits, starts with 5)
  const phoneRegex = /^5\d{8}$/;
  // idNo simple numeric check (10-12 digits)
  const idRegex = /^\d{6,12}$/;
  // gpa numeric (0.0 - 4.0) or (0-100) adjust as needed; we'll check 0-4
  const validateField = (name, value, isAcademic = false) => {
    if (!isAcademic) {
      switch (name) {
        case "first_name":
        case "second_name":
        case "third_name":
        case "fourth_name":
        // case "fullName":
        //   return value ? "" : t("admissions.errors.required") || "Required";
        case "gender":
          return value ? "" : t("admissions.errors.required") || "Required";

        case "nationality_id":
          return value ? "" : t("admissions.errors.required") || "Required";
        case "birthdate":
          return value ? "" : t("admissions.errors.required") || "Required";
        case "email":
          if (!value) return t("admissions.errors.required") || "Required";
          if (!emailRegex.test(value))
            return t("admissions.errors.invalidEmail") || "Invalid email";
          return "";
        case "mobile":
          // return value ? "" : t("admissions.errors.invalidPhone") || "Required";
          if (!value) return t("admissions.errors.required") || "Required";
        // if (!phoneRegex.test(value))
        //   return t("admissions.errors.invalidPhone") || "Invalid phone";
        // return "";

        case "home_tel":
          return value ? "" : t("admissions.errors.required") || "Required";
        case "national_id":
          if (!value) return t("admissions.errors.required") || "Required";
          // if (!idRegex.test(value))
          //   return t("admissions.errors.invalidId") || "Invalid ID number";
          return "";

        case "national_id_type":
          return value
            ? ""
            : t("admissions.errors.nationality_select") || "Required";

        default:
          return "";
      }
    } else {
      // academic validations
      switch (name) {
        case "education_year":
        case "study_place":
        case "country_id":
        case "city_id":
        case "high_school_student_number":
        case "general_grade":
        case "faculty_id":
        case "faculty_department_id":
          return value ? "" : t("admissions.errors.required") || "Required";
        case "academyTerm_id":
          return value ? "" : t("admissions.errors.required") || "Required";
        case "gpa":
          if (!value) return t("admissions.errors.required") || "Required";
          // allow decimal like 3.25 and check range 0-4
          const num = Number(value);
          if (Number.isNaN(num))
            return t("admissions.errors.invalidNumber") || "Invalid number";
          if (num < 0 || num > 4)
            return (
              t("admissions.errors.invalidGpaRange") ||
              "GPA must be between 0 and 4"
            );
          return "";
        case "high_school_certificate_file":
          return value
            ? ""
            : t("admissions.errors.requiredFile") ||
            "Please attach certificate file";
        case "academic_record":
          return value
            ? ""
            : t("admissions.errors.requiredFile") ||
            "Please attach academic record file";
        default:
          return "";
      }
    }
  };

  const validateStep1 = () => {
    const keys = [
      "first_name",
      "second_name",
      "third_name",
      "fourth_name",
      // "fullName",
      "gender",
      "nationality_id",
      "birthdate",
      "email",
      "mobile",
      "national_id",
      "national_id_type",
      "home_tel",
    ];
    const newErrors = {};

    logger.log("personal", personal);

    keys.forEach((k) => {
      const msg = validateField(k, personal[k], false);
      if (msg) newErrors[k] = msg;
    });
    setErrors(newErrors);

    logger.log("personal error", newErrors);

    // newErrors?.national_id_type
    if (newErrors?.national_id_type)
      notify(newErrors?.national_id_type, "error");

    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const keys = [
      "education_year",
      "study_place",
      "country_id",
      "city_id",
      "high_school_student_number",
      "general_grade",
      "gpa",
      "high_school_certificate_file",
      "academic_record",
      "faculty_id",
      "faculty_department_id",
      "academyTerm_id"
    ];
    const newErrors = {};
    keys.forEach((k) => {
      const msg = validateField(k, academic[k], true);
      if (msg) newErrors[k] = msg;
    });

    logger.log("newErrors", newErrors);
    setAcadErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // single-field onBlur validation (for immediate feedback)
  const handlePersonalBlur = (field) => {
    logger.log("field", field, "personal[field]", personal[field]);

    const msg = validateField(field, personal[field], false);

    logger.log("msg personal", msg);
    setErrors((prev) => ({ ...prev, [field]: msg }));
  };

  const handleAcademicBlur = (field) => {
    const msg = validateField(field, academic[field], true);
    setAcadErrors((prev) => ({ ...prev, [field]: msg }));
  };

  const handleNext = () => {
    if (validateStep1()) {
      setStep(2);
      // scroll to top of step2 maybe
    }
  };

  const handleFinish = async () => {
    // try {

    // return setShowPaymentModal(true);
    logger.log("finish", validateStep2());
    if (validateStep2()) {
      // logger.log('oooooooooooooooo');
      const formData = new FormData();

      // Append personal data
      Object.entries(personal).forEach(([key, value]) => {
        // لو قيمة Boolean زي checkboxes نخليها string
        if (key == "countryCode") return;
        formData.append(
          key,
          typeof value === "boolean" ? String(value) : value
        );
      });

      // Append academic data
      Object.entries(academic).forEach(([key, value]) => {
        if ((key === "high_school_certificate_file" || key === "academic_record") && value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, typeof value === "boolean" ? String(value) : value);
        }
      });

      logger.log("formData", formData);
      let objToSend = {
        address: "aaaaaaaaaaaaaa",
      };
      for (let [key, value] of formData.entries()) {
        logger.log(key, value);
        objToSend[key] = value;
      }
      objToSend.is_clearance = objToSend.is_clearance === "true" || objToSend.is_clearance === true;

      logger.log("objToSend", objToSend);
      setIsLoading(true);
      const result = await createRegisterForm({
        variables: {
          input: objToSend,
        },
      });
      setIsLoading(false);
      logger.log("result", result?.data?.createRegisterForm);
      if (result?.data?.createRegisterForm?.success) {
        setRegisterationFeesResults(result?.data?.createRegisterForm);
        const feesVal = result?.data?.createRegisterForm?.registration_Fees_Value;
        const feesId = result?.data?.createRegisterForm?.registration_Fees_Id;

        if (feesVal && feesId) {
          setShowPaymentModal(true);
        } else {
          notify(result?.data?.createRegisterForm?.message || t("admissions.success"), "success");
          setTimeout(() => navigate('/login'), 2500);
        }
      } else {
        notify(result?.data?.createRegisterForm?.message, "error");
      }

    }
  };

  const handleSubmitPayment = async () => {
    try {
      const feesVal = registerationFeesResults?.registration_Fees_Value;
      const feesId = registerationFeesResults?.registration_Fees_Id;

      if (!feesVal || !feesId) {
        notify(t("admissions.error") || "Missing registration fees", "error");
        return;
      }

      if (selectedPaymnetMethod === 'ONLINE') {
        const result = await initiateOnlinePayment({
          variables: {
            input: {
              transaction_type_id: "69de135ce9799b76cf8806a8",
              user_id: registerationFeesResults?.user?.id || null,
              register_form_id: String(registerationFeesResults?.form?.id),
              source_type: "REGISTER_FORM",
              fees_type_ids: [feesId],
              amount: Number(feesVal),
              customer_name: `${personal.first_name} ${personal.second_name} ${personal.third_name} ${personal.fourth_name}`.trim(),
              customer_email: personal.email,
              customer_mobile: personal.mobile,
              language: i18n.language === "ar" ? "ar" : "en"
            }
          }
        });
        
        if (result?.data?.initiateOnlinePayment?.paymentUrl) {
           window.location.href = result.data.initiateOnlinePayment.paymentUrl;
        } else {
           notify(t("admissions.error"), "error");
        }
        return;
      }

      // in transaction type id
      const transaction_type_id = "69de135ce9799b76cf8806a8";
      let transactionObj = {
        payment_method_type: selectedPaymnetMethod,
        transaction_type_id,
        user_id: registerationFeesResults?.user?.id || null,
        fees_type_ids: [feesId],
        transaction_date: formatDateToString(new Date()),
        amount: Number(feesVal),
        register_form_id: registerationFeesResults?.form?.id,
        source_type: "REGISTER_FORM",
        payment_document_file: paymentDocumentFile,
      };

      logger.log("transactionObj", transactionObj);
      const result = await createTransaction({
        variables: {
          input: transactionObj,
        },
      });

      logger.log("payment result", result?.data?.createTransaction);

      notify(t("admissions.paymentSuccess"), "success");
      setShowPaymentModal(false);

      setTimeout(() => navigate('/login'), 2000);

    } catch (error) {
      logger.log("error", error);
      notify(t("admissions.error"), "error");
    }
  };

  // File handling
  const handlePickFile = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    setAcademic((a) => ({ ...a, high_school_certificate_file: file }));
    // validate file right away
    const msg = validateField("high_school_certificate_file", file, true);
    setAcadErrors((prev) => ({ ...prev, high_school_certificate_file: msg }));

    if (!file) return;

    setSelectedFile(file?.name);
    setUploadError("");
    setUploadProgress(0);
    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();

    // Track upload progress
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percent);
      }
    });

    // Handle successful completion
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const data = JSON.parse(xhr.responseText);
          logger.log("Upload successful:", data);
          setAcademic((a) => ({
            ...a,
            high_school_certificate_file: `${baseURL}${data?.url}`,
          }));
          setUploadProgress(100);
          setUploadError("");
        } catch (parseError) {
          setUploadError(t("admissions.errorUplaod") || "Upload failed");
          notify(t("admissions.errorUplaod") || "Upload failed", "error");
          setUploadProgress(0);
        }
      } else {
        setUploadError(t("admissions.errorUplaod") || "Upload failed");
        notify(t("admissions.errorUplaod") || "Upload failed", "error");
        setUploadProgress(0);
      }
      setIsUploading(false);
    });

    // Handle network errors
    xhr.addEventListener("error", () => {
      setUploadError(t("admissions.errorUplaod") || "Upload failed");
      notify(t("admissions.errorUplaod") || "Upload failed", "error");
      setIsUploading(false);
      setUploadProgress(0);
    });

    // Handle abort
    xhr.addEventListener("abort", () => {
      setUploadError(t("admissions.errorUplaod") || "Upload cancelled");
      setIsUploading(false);
      setUploadProgress(0);
    });

    xhr.open("POST", `${baseURL}/api/forms/single`);
    xhr.send(formData);
  };

  const handlePickAcademicRecordFile = () => {
    if (academicRecordInputRef.current) academicRecordInputRef.current.click();
  };
  const handleAcademicRecordFileChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    setAcademic((a) => ({ ...a, academic_record: file }));
    // validate file right away
    const msg = validateField("academic_record", file, true);
    setAcadErrors((prev) => ({ ...prev, academic_record: msg }));

    if (!file) return;

    setSelectedAcademicRecordFile(file?.name);
    setUploadAcademicRecordError("");
    setUploadAcademicRecordProgress(0);
    setIsUploadingAcademicRecord(true);

    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();

    // Track upload progress
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setUploadAcademicRecordProgress(percent);
      }
    });

    // Handle successful completion
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const data = JSON.parse(xhr.responseText);
          logger.log("Upload successful:", data);
          setAcademic((a) => ({
            ...a,
            academic_record: `${baseURL}${data?.url}`,
          }));
          setUploadAcademicRecordProgress(100);
          setUploadAcademicRecordError("");
        } catch (parseError) {
          setUploadAcademicRecordError(t("admissions.errorUplaod") || "Upload failed");
          notify(t("admissions.errorUplaod") || "Upload failed", "error");
          setUploadAcademicRecordProgress(0);
        }
      } else {
        setUploadAcademicRecordError(t("admissions.errorUplaod") || "Upload failed");
        notify(t("admissions.errorUplaod") || "Upload failed", "error");
        setUploadAcademicRecordProgress(0);
      }
      setIsUploadingAcademicRecord(false);
    });

    // Handle network errors
    xhr.addEventListener("error", () => {
      setUploadAcademicRecordError(t("admissions.errorUplaod") || "Upload failed");
      notify(t("admissions.errorUplaod") || "Upload failed", "error");
      setIsUploadingAcademicRecord(false);
      setUploadAcademicRecordProgress(0);
    });

    // Handle abort
    xhr.addEventListener("abort", () => {
      setUploadAcademicRecordError(t("admissions.errorUplaod") || "Upload cancelled");
      setIsUploadingAcademicRecord(false);
      setUploadAcademicRecordProgress(0);
    });

    xhr.open("POST", `${baseURL}/api/forms/single`);
    xhr.send(formData);
  };

  const handlePaymentDocChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    if (!file) return;

    setIsUploadingPaymentDoc(true);
    setUploadPaymentDocProgress(0);

    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setUploadPaymentDocProgress(percent);
      }
    });

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const data = JSON.parse(xhr.responseText);
          setPaymentDocumentFile(`${baseURL}${data?.url}`);
          setUploadPaymentDocProgress(100);
        } catch (parseError) {
          notify(t("admissions.errorUplaod") || "Upload failed", "error");
        }
      } else {
        notify(t("admissions.errorUplaod") || "Upload failed", "error");
      }
      setIsUploadingPaymentDoc(false);
    });

    xhr.addEventListener("error", () => {
      notify(t("admissions.errorUplaod") || "Upload failed", "error");
      setIsUploadingPaymentDoc(false);
    });

    xhr.open("POST", `${baseURL}/api/forms/single`);
    xhr.send(formData);
  };

  logger.log("i18n ", i18n.language);

  logger.log("academic.city", academic.city);

  logger.log("setSelectedPaymentMethod", selectedPaymnetMethod);

  logger.log("fileInputRef", fileInputRef);

  logger.log('countriesLoading', countriesLoading);

  // Check if initial data is still loading
  const initialLoading = ArticalesLoading || nationalitiesLoading || countriesLoading || faculitiesLoading;

  if (initialLoading) {
    return (
   <LoadingPage />
    );
  }

  return (
    <Box>
      {showPaymentModal && (
        <Dialog
          open={showPaymentModal}
          onClose={() => setShowPaymentModal(false)}
          PaperProps={{
            sx: {
              position: "absolute",
              top: 20, // المسافة من أعلى الصفحة
              margin: 0,
              borderRadius: 3,
              overflow: "hidden"
            },
          }}
          fullWidth // يخليه ياخد 100% من maxWidth
          maxWidth="xs"
        >
          {/* Success Banner */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              p: 3,
              backgroundColor: "rgba(76, 175, 80, 0.08)", // Soft green background
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 56, mb: 1.5, color: theme.palette.success.main }} />
            <Typography variant="h6" sx={{ fontWeight: 800, color: theme.palette.success.main }}>
              {t("admissions.success")}
            </Typography>
            {registerationFeesResults?.user?.fullname && (
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary", fontWeight: 500 }}>
                {registerationFeesResults.user.fullname}
              </Typography>
            )}
          </Box>

          <DialogTitle
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 800,
              pt: 2.5,
              pb: 1,
              textAlign: "center",
            }}
          >
            {t("admissions.Pay")}:{" "}
            {registerationFeesResults?.registration_Fees_Value}
          </DialogTitle>
          <Box sx={{ mx: 3 }}>
            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                variant="contained"
                sx={{ display: "block", fontWeight: 800, mb: 2 }}
                id="demo-radio-buttons-group-label"
              >
                {t("admissions.paymentMethods")}
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {paymentMethods?.map((el, i) => (
                  <FormControlLabel
                    sx={{
                      backgroundColor: "#E5E5E5",
                      m: 0, // يشيل الـ margin الخارجي
                      p: 0, // يشيل الـ padding الداخلي
                      "& .MuiFormControlLabel-label": {
                        fontWeight: 500, // ← هنا تغيّر السماكة (400 عادي - 500 متوسط - 700 عريض)
                      },
                    }}
                    key={i}
                    value={el?.value}
                    control={<Radio />}
                    onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                    label={el?.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {(selectedPaymnetMethod === "CASH" || selectedPaymnetMethod === "BANK_TRANSFER") && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
                  {t("admissions.uploadReceipt")}
                </Typography>
                <input
                  type="file"
                  hidden
                  ref={paymentDocInputRef}
                  onChange={handlePaymentDocChange}
                  accept="image/*"
                />
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => paymentDocInputRef.current?.click()}
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{ py: 1.5 }}
                >
                  {paymentDocumentFile ? t("admissions.changeReceipt") : t("admissions.selectReceipt")}
                </Button>
                {isUploadingPaymentDoc && (
                  <Box sx={{ mt: 1 }}>
                    <LinearProgress variant="determinate" value={uploadPaymentDocProgress} />
                  </Box>
                )}
                {paymentDocumentFile && !isUploadingPaymentDoc && (
                  <Box sx={{ mt: 1, textAlign: "center" }}>
                    <img 
                      src={paymentDocumentFile} 
                      alt="Payment Receipt" 
                      style={{ maxWidth: "100%", maxHeight: 200, borderRadius: 8, marginTop: 8 }} 
                    />
                  </Box>
                )}
              </Box>
            )}
          </Box>

          <DialogActions sx={{ mx: 1 }}>
            {/* <Button onClick={() => setShowPaymentModal(false)}>إلغاء</Button> */}
            <Button
              variant="contained"
              disabled={transactionLoading || onlinePaymentLoading}
              sx={{ width: "100%", mt: 1 }}
              onClick={() => {
                if (!selectedPaymnetMethod) {
                  return notify(t("admissions.paymentMethods") || "Please select a payment method", "error");
                }
                if ((selectedPaymnetMethod === "CASH" || selectedPaymnetMethod === "BANK_TRANSFER") && !paymentDocumentFile) {
                  return notify(t("admissions.errors.requiredFile"), "error");
                }
                handleSubmitPayment();
              }}
            >
              {(transactionLoading || onlinePaymentLoading) ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                t("submit")
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!fromAdmin && <AdmissionsHero data={ArticalesData?.getArticlesByDepartment?.[0]} />}

      {!acceptTerms && !fromAdmin && (
        <TermsConditions
          setAcceptTerms={setAcceptTerms}
          acceptTerms={acceptTerms}
          data={ArticalesData?.getArticlesByDepartment?.slice(1)}
        />
      )}

      {acceptTerms && (
        <Box sx={{ mt: 3, maxWidth: 900, margin: "auto" }}>
          {/* Step header */}
          { (
            <Box sx={{ my: 2 }}>
              <Typography variant="subtitle2">
                {t("admissions.step", { step })}
              </Typography>
              <Box sx={{ mt: 1 }}>
                <LinearProgress
                  variant="determinate"
                  value={step === 1 ? 50 : 100}
                  sx={{
                    height: 10,
                    borderRadius: 2,
                    backgroundColor: "#CFDBE8",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
            </Box>
          )}

          {/* Paper with big border */}
          <Paper
            elevation={0}
            sx={{ border: `10px solid ${theme.palette.divider}`, p: 3, mb: 3 }}
          >
            {step === 1 && (
              <>
                <Typography
                  variant="h6"
                  sx={{ color: theme.palette.info?.main }}
                >
                  {t("admissions.personalInformation")}
                </Typography>
                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  {[
                    { key: "first_name", label: t("admissions.firstName") },
                    { key: "second_name", label: t("admissions.secondName") },
                    { key: "third_name", label: t("admissions.thirdName") },
                    { key: "fourth_name", label: t("admissions.fourthName") },
                  ].map((field) => (
                    <Grid key={field.key} item xs={12} sm={6} md={3}>
                      <Typography
                        variant="body2"
                        sx={{ display: "block", mb: 0.5 }}
                      >
                        {field.label}
                      </Typography>
                      <CustomTextField
                        placeholder={field.label}
                        value={personal[field.key]}
                        onChange={(e) =>
                          setPersonal((p) => ({
                            ...p,
                            [field.key]: e.target.value,
                          }))
                        }
                        onBlur={() => handlePersonalBlur(field.key)}
                        error={!!errors[field.key]}
                        helperText={errors[field.key] || ""}
                      />
                    </Grid>
                  ))}

                  {/* <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.fullName")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.fullName")}
                      value={personal.fullName}
                      onChange={(e) =>
                        setPersonal((p) => ({ ...p, fullName: e.target.value }))
                      }
                      onBlur={() => handlePersonalBlur("fullName")}
                      error={!!errors.fullName}
                      helperText={errors.fullName || ""}
                    />
                  </Grid> */}

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.gender")}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("admissions.gender")}
                      value={personal.gender}
                      onChange={(e) =>
                        setPersonal((p) => ({ ...p, gender: e.target.value }))
                      }
                      onBlur={() => handlePersonalBlur("gender")}
                      error={!!errors.gender}
                      helperText={errors.gender || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return (
                              <span style={{ color: "#aaa" }}>
                                {t("Select Type")}
                              </span>
                            );
                          }

                          // 👇 استرجاع الاسم المناسب حسب اللغة
                          const genderLabel = genders.find(
                            (g) => g.value === selected
                          )?.label;
                          return <>{genderLabel}</>;
                        },
                        MenuProps: {
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      {genders.map((g) => (
                        <MenuItem key={g.value} value={g.value}>
                          {g.label}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.nationality")}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("admissions.nationality")}
                      value={personal.nationality_id}
                      onChange={(e) => {
                        logger.log("e.target.value", e.target);
                        setPersonal((p) => ({
                          ...p,
                          nationality_id: e.target.value,
                        }));
                      }}
                      onBlur={() => handlePersonalBlur("nationality_id")}
                      error={!!errors.nationality_id}
                      helperText={errors.nationality_id || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return <>{t("Select Nationality")}</>;
                          }
                          return (
                            <>
                              {i18n.language === "ar"
                                ? nationalities?.find(
                                  (city) => city?.id === selected
                                )?.name_ar
                                : cities?.find((city) => city?.id === selected)
                                  ?.name_en}
                            </>
                          );
                        },
                        MenuProps: {
                          // optional: keep menu within viewport
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      {nationalities?.map((n) => (
                        <MenuItem key={n?.id} value={n?.id}>
                          {/* {n.label} */}
                          {i18n.language === "ar" ? n?.name_ar : n?.name_en}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.dateOfBirth")}
                    </Typography>
                    <CustomTextField
                      type="date"
                      value={personal.birthdate}
                      onChange={(e) =>
                        setPersonal((p) => ({
                          ...p,
                          birthdate: e.target.value,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                      onBlur={() => handlePersonalBlur("birthdate")}
                      error={!!errors.birthdate}
                      helperText={errors.birthdate || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.email")}
                    </Typography>
                    <CustomTextField
                      placeholder="example@mail.com"
                      type="email"
                      value={personal.email}
                      onChange={(e) =>
                        setPersonal((p) => ({ ...p, email: e.target.value }))
                      }
                      onBlur={() => handlePersonalBlur("email")}
                      error={!!errors.email}
                      helperText={errors.email || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.homePhone")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.homePhone")}
                      value={personal.home_tel}
                      onChange={(e) =>
                        setPersonal((p) => ({
                          ...p,
                          home_tel: e.target.value,
                        }))
                      }
                      onBlur={() => handlePersonalBlur("home_tel")}
                      error={!!errors.home_tel}
                      helperText={errors.home_tel || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="caption"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.phoneNumber")}
                    </Typography>
                    {/* phone as text but validated by regex */}
                    <PhoneNumberInput
                      personal={personal ?? { mobile: "", countryCode: "" }}
                      setPersonal={setPersonal ?? (() => { })}
                      errors={errors ?? {}}
                      handlePersonalBlur={handlePersonalBlur ?? (() => { })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.idNo")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.idNo")}
                      type="text"
                      value={personal.national_id}
                      onChange={(e) =>
                        setPersonal((p) => ({
                          ...p,
                          national_id: e.target.value,
                        }))
                      }
                      onBlur={() => handlePersonalBlur("national_id")}
                      error={!!errors.national_id}
                      helperText={errors.national_id || ""}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", gap: 2, alignItems: "end" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            personal?.national_id_type == "id_card"
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "id_card",
                              }));
                            } else {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "",
                              }));
                            }
                          }}
                        />
                      }
                      label={t("admissions.idCard")}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            personal?.national_id_type == "passport"
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "passport",
                              }));
                            } else {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "",
                              }));
                            }
                          }}
                        />
                      }
                      label={t("admissions.passport")}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            personal?.national_id_type == "residence_no"
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "residence_no",
                              }));
                            } else {
                              setPersonal((p) => ({
                                ...p,
                                national_id_type: "",
                              }));
                            }
                          }}
                        />
                      }
                      label={t("admissions.residenceNo")}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {step === 2 && (
              <>
                <Typography
                  variant="h6"
                  sx={{ color: theme.palette.info?.main }}
                >
                  {t("admissions.academicInformation")}
                </Typography>
                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.yearOfEducation")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.yearOfEducation")}
                      value={academic.education_year}
                      onChange={(e) =>
                        setAcademic((a) => ({
                          ...a,
                          education_year: e.target.value,
                        }))
                      }
                      onBlur={() => handleAcademicBlur("education_year")}
                      error={!!acadErrors.education_year}
                      helperText={acadErrors.education_year || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.placeOfStudy")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.placeOfStudy")}
                      value={academic.study_place}
                      onChange={(e) =>
                        setAcademic((a) => ({
                          ...a,
                          study_place: e.target.value,
                        }))
                      }
                      onBlur={() => handleAcademicBlur("study_place")}
                      error={!!acadErrors.study_place}
                      helperText={acadErrors.study_place || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.country")}
                    </Typography>
                    <CustomTextField
                      select
                      id="country"
                      placeholder={t("admissions.country")}
                      value={academic.country_id}
                      onChange={(e) => {
                        setAcademic((a) => ({
                          ...a,
                          country_id: e.target.value,
                        }));
                        // get cities in selected country
                        if (e.target.value != "") {
                          // 44444444444444444444444444
                          getCitiesByCountry({
                            variables: {
                              country_id: e.target.value,
                            },
                          });
                        }
                      }}
                      onBlur={() => handleAcademicBlur("country_id")}
                      error={!!acadErrors.country_id}
                      helperText={acadErrors.country_id || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return <>{t("Select Country")}</>;
                          }
                          return (
                            <>
                              {i18n.language === "ar"
                                ? countries?.find(
                                  (city) => city?.id === selected
                                )?.name_ar
                                : cities?.find((city) => city?.id === selected)
                                  ?.name_en}
                            </>
                          );
                        },
                        MenuProps: {
                          // optional: keep menu within viewport
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      {countries?.map((country) => (
                        <MenuItem key={country?.id} value={country?.id}>
                          {i18n.language === "ar"
                            ? country?.name_ar
                            : country?.name_en}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.city")}
                    </Typography>

                    <FormControl fullWidth>
                      <CustomTextField
                        select
                        id="city"
                        placeholder={t("admissions.city")}
                        value={academic.city_id || ""}
                        onChange={(e) =>
                          setAcademic((a) => ({
                            ...a,
                            city_id: e.target.value,
                          }))
                        }
                        onBlur={() => handleAcademicBlur("city_id")}
                        error={!!acadErrors.city_id}
                        helperText={acadErrors.city_id || ""}
                        SelectProps={{
                          displayEmpty: true,
                          renderValue: (selected) => {
                            if (!selected) {
                              return <>{t("Select City")}</>;
                            }
                            return (
                              <>
                                {i18n.language === "ar"
                                  ? cities?.find(
                                    (city) => city?.id === selected
                                  )?.name_ar
                                  : cities?.find(
                                    (city) => city?.id === selected
                                  )?.name_en}
                              </>
                            );
                          },
                          MenuProps: {
                            // optional: keep menu within viewport
                            PaperProps: { style: { maxHeight: 320 } },
                          },
                        }}
                      >
                        <MenuItem key="0" value="">
                          {t("Select City")}
                        </MenuItem>
                        {cities?.map((city) => (
                          <MenuItem key={city?.id} value={city?.id}>
                            {i18n.language === "ar"
                              ? city?.name_ar
                              : city?.name_en}
                          </MenuItem>
                        ))}
                      </CustomTextField>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.studentNo")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.studentNo")}
                      value={academic.high_school_student_number}
                      onChange={(e) =>
                        setAcademic((a) => ({
                          ...a,
                          high_school_student_number: e.target.value,
                        }))
                      }
                      onBlur={() =>
                        handleAcademicBlur("high_school_student_number")
                      }
                      error={!!acadErrors.high_school_student_number}
                      helperText={acadErrors.high_school_student_number || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.generalAppreciation")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.generalAppreciation")}
                      value={academic.general_grade}
                      onChange={(e) =>
                        setAcademic((a) => ({
                          ...a,
                          general_grade: e.target.value,
                        }))
                      }
                      onBlur={() => handleAcademicBlur("general_grade")}
                      error={!!acadErrors.general_grade}
                      helperText={acadErrors.general_grade || ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.gpa")}
                    </Typography>
                    <CustomTextField
                      placeholder={t("admissions.gpa")}
                      type="text"
                      value={academic.gpa}
                      onChange={(e) =>
                        setAcademic((a) => ({ ...a, gpa: e.target.value }))
                      }
                      onBlur={() => handleAcademicBlur("gpa")}
                      error={!!acadErrors.gpa}
                      helperText={acadErrors.gpa || ""}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      {t("admissions.highSchoolCertificate")}
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        border: `2px dashed ${theme.palette.secondary.main}`,
                        p: 2,
                        mt: 1,
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="body2">
                        {t("admissions.certificateDescription")}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 2,
                          gap: 2,
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <input
                          ref={fileInputRef}
                          type="file"
                          hidden
                          onChange={handleFileChange}
                        // value={selectedFile}
                        />
                        <Button
                          variant="contained"
                          sx={{
                            background: theme.palette.secondary.main,
                            width: "150px",
                            gap: 1,
                          }}
                          endIcon={
                            <AddCircleOutlineIcon
                              sx={{
                                transform:
                                  i18n.language === "ar"
                                    ? "rotate(180deg)"
                                    : "none",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          onClick={handlePickFile}
                        >
                          {t("admissions.addFile")}
                        </Button>
                        <Typography
                          variant="body2"
                          sx={{ alignSelf: "center" }}
                        >
                          {selectedFile ? selectedFile : ""}
                        </Typography>

                        {/* Upload progress bar */}
                        {isUploading && (
                          <Box sx={{ width: "100%", mt: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ flex: 1 }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={uploadProgress}
                                  sx={{
                                    height: 8,
                                    borderRadius: 4,
                                    backgroundColor: "#e0e0e0",
                                    "& .MuiLinearProgress-bar": {
                                      borderRadius: 4,
                                      backgroundColor: theme.palette.primary.main,
                                    },
                                  }}
                                />
                              </Box>
                              <Typography variant="body2" sx={{ minWidth: 40, fontWeight: 600 }}>
                                {uploadProgress}%
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {/* Upload complete indicator */}
                        {!isUploading && uploadProgress === 100 && !uploadError && (
                          <Typography variant="body2" sx={{ color: "green", mt: 1, fontWeight: 600 }}>
                            {t("admissions.uploadComplete") || "✔ Upload complete"}
                          </Typography>
                        )}

                        {/* Upload error message */}
                        {uploadError && (
                          <Typography variant="body2" sx={{ color: "error.main", mt: 1, fontWeight: 600 }}>
                            {uploadError}
                          </Typography>
                        )}

                      </Box>
                      {acadErrors.high_school_certificate_file && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ display: "block", mt: 1 }}
                        >
                          {acadErrors.high_school_certificate_file}
                        </Typography>
                      )}
                    </Box>
                  </Grid>

                  {/* Clearance status */}
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("Student Type") || "Student Type"}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("Student Type") || "Student Type"}
                      value={academic.is_clearance ? "true" : "false"}
                      onChange={(e) =>
                        setAcademic((a) => ({ ...a, is_clearance: e.target.value === "true" }))
                      }
                      onBlur={() => handleAcademicBlur("is_clearance")}
                      error={!!acadErrors.is_clearance}
                      helperText={acadErrors.is_clearance || ""}
                    >
                      <MenuItem value="false">
                        {isArabic ? "طالب مستجد" : "New Student"}
                      </MenuItem>
                      <MenuItem value="true">
                        {isArabic ? "طالب نقل" : "Transfer Student"}
                      </MenuItem>
                    </CustomTextField>
                  </Grid>

                  {/* Academic record upload */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      {t("Academic Record") || "Academic Record"}
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        border: `2px dashed ${theme.palette.secondary.main}`,
                        p: 2,
                        mt: 1,
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="body2">
                        {t("admissions.academicRecordDescription") || "Please attach academic record file"}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 2,
                          gap: 2,
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <input
                          ref={academicRecordInputRef}
                          type="file"
                          hidden
                          onChange={handleAcademicRecordFileChange}
                        />
                        <Button
                          variant="contained"
                          sx={{
                            background: theme.palette.secondary.main,
                            width: "150px",
                            gap: 1,
                          }}
                          endIcon={
                            <AddCircleOutlineIcon
                              sx={{
                                transform:
                                  i18n.language === "ar"
                                    ? "rotate(180deg)"
                                    : "none",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          onClick={handlePickAcademicRecordFile}
                        >
                          {t("admissions.addFile")}
                        </Button>
                        <Typography
                          variant="body2"
                          sx={{ alignSelf: "center" }}
                        >
                          {selectedAcademicRecordFile ? selectedAcademicRecordFile : ""}
                        </Typography>

                        {/* Upload progress bar */}
                        {isUploadingAcademicRecord && (
                          <Box sx={{ width: "100%", mt: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ flex: 1 }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={uploadAcademicRecordProgress}
                                  sx={{
                                    height: 8,
                                    borderRadius: 4,
                                    backgroundColor: "#e0e0e0",
                                    "& .MuiLinearProgress-bar": {
                                      borderRadius: 4,
                                      backgroundColor: theme.palette.primary.main,
                                    },
                                  }}
                                />
                              </Box>
                              <Typography variant="body2" sx={{ minWidth: 40, fontWeight: 600 }}>
                                {uploadAcademicRecordProgress}%
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {/* Upload complete indicator */}
                        {!isUploadingAcademicRecord && uploadAcademicRecordProgress === 100 && !uploadAcademicRecordError && (
                          <Typography variant="body2" sx={{ color: "green", mt: 1, fontWeight: 600 }}>
                            {t("admissions.uploadComplete") || "✔ Upload complete"}
                          </Typography>
                        )}

                        {/* Upload error message */}
                        {uploadAcademicRecordError && (
                          <Typography variant="body2" sx={{ color: "error.main", mt: 1, fontWeight: 600 }}>
                            {uploadAcademicRecordError}
                          </Typography>
                        )}

                      </Box>
                      {acadErrors.academic_record && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ display: "block", mt: 1 }}
                        >
                          {acadErrors.academic_record}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}
          </Paper>

          {step === 1 && (
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end", my: 2 }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={
                  <KeyboardDoubleArrowRightIcon
                    sx={{
                      transform:
                        i18n.language === "ar" ? "rotate(180deg)" : "none",
                      transition: "transform 0.3s ease",
                    }}
                  />
                }
                sx={{ background: theme.palette.info?.main, gap: 1 }}
                onClick={handleNext}
              >
                {t("admissions.next")}
              </Button>
            </Grid>
          )}
          {/* Major Information Paper */}
          {step === 2 && (
            <Grid item xs={12}>
              <Paper
                elevation={0}
                sx={{
                  border: `10px solid ${theme.palette.divider}`,
                  p: 2,
                  mt: 3,
                }}
              >
                <Typography variant="h6">
                  {t("admissions.majorInformation")}
                </Typography>
                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.faculty")}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("admissions.faculty")}
                      value={academic.faculty_id}
                      onChange={(e) => {
                        if (e.target.value != "") {
                          getFacultyDepartmentsByFaculty({
                            variables: {
                              faculty_id: e.target.value,
                            },
                          });
                          setAcademic((a) => ({
                            ...a,
                            faculty_id: e.target.value,
                          }));
                        }
                      }}
                      onBlur={() => handleAcademicBlur("faculty_id")}
                      error={!!acadErrors.faculty_id}
                      helperText={acadErrors.faculty_id || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return <>{t("admissions.faculty")}</>;
                          }
                          return (
                            <>
                              {i18n.language === "ar"
                                ? faculties?.find(
                                  (city) => city?.id === selected
                                )?.title_ar
                                : cities?.find((city) => city?.id === selected)
                                  ?.title_en}
                            </>
                          );
                        },
                        MenuProps: {
                          // optional: keep menu within viewport
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      {faculties?.map((faculty) => (
                        <MenuItem key={faculty?.id} value={faculty?.id}>
                          {i18n.language === "ar"
                            ? faculty?.title_ar
                            : faculty?.title_en}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.facultyDepartment")}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("admissions.facultyDepartment")}
                      value={academic.faculty_department_id}
                      onChange={(e) => {
                        // 44444444444444444444444444444
                        if (e.target.value != "") {
                          logger.log("nnnnnnnnnnnnn", e.target.value);
                          getAcademyTermsByFacultyDepartment({
                            variables: {
                              faculty_department_id: e.target.value
                            }
                          });

                          setAcademic((a) => ({
                            ...a,
                            faculty_department_id: e.target.value,
                          }));
                        }

                      }}
                      onBlur={() => handleAcademicBlur("faculty_department_id")}
                      error={!!acadErrors.faculty_department_id}
                      helperText={acadErrors.faculty_department_id || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return <>{t("admissions.facultyDepartment")}</>;
                          }
                          return (
                            <>
                              {i18n.language === "ar"
                                ? departments?.find(
                                  (city) => city?.id === selected
                                )?.title_ar
                                : cities?.find((city) => city?.id === selected)
                                  ?.title_en}
                            </>
                          );
                        },
                        MenuProps: {
                          // optional: keep menu within viewport
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      <MenuItem value="">
                        {i18n.language === "ar"
                          ? "اختر القسم"
                          : "Select Faculty"}
                      </MenuItem>

                      {departments?.map((dept) => (
                        <MenuItem key={dept?.id} value={dept?.id}>
                          {i18n.language === "ar"
                            ? dept?.title_ar
                            : dept?.title_en}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>


                  {/* الترم */}
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      sx={{ display: "block", mb: 0.5 }}
                    >
                      {t("admissions.departmentTerm")}
                    </Typography>
                    <CustomTextField
                      select
                      placeholder={t("admissions.departmentTerm")}
                      value={academic.academyTerm_id}
                      onChange={(e) => {
                        // 44444444444444444444444444444
                        if (e.target.value != "") {

                          setAcademic((a) => ({
                            ...a,
                            academyTerm_id: e.target.value,
                          }));
                        }

                      }}
                      onBlur={() => handleAcademicBlur("academyTerm_id")}
                      error={!!acadErrors.academyTerm_id}
                      helperText={acadErrors.academyTerm_id || ""}
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return <>{t("admissions.departmentTerm")}</>;
                          }
                          return (
                            <>
                              {i18n.language === "ar"
                                ? termsData?.find(
                                  (city) => city?.id === selected
                                )?.title_ar
                                : termsData?.find((city) => city?.id === selected)
                                  ?.title_en}
                            </>
                          );
                        },
                        MenuProps: {
                          // optional: keep menu within viewport
                          PaperProps: { style: { maxHeight: 320 } },
                        },
                      }}
                    >
                      <MenuItem value="">
                        {i18n.language === "ar"
                          ? "اختر السنة الدراسية"
                          : "Select Study Year"}
                      </MenuItem>

                      {termsData?.map((dept) => (
                        <MenuItem key={dept?.id} value={dept?.id}>
                          {i18n.language === "ar"
                            ? dept?.title_ar
                            : dept?.title_en}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>

                </Grid>
              </Paper>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between", my: 2 }}
              >
                { (
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={
                      <KeyboardDoubleArrowRightIcon
                        sx={{
                          transform:
                            i18n.language === "ar" ? "rotate(180deg)" : "none",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    }
                    sx={{ background: theme.palette.info?.main, gap: 1 }}
                    onClick={() => setStep(1)}
                  >
                    {t("Back")}
                  </Button>
                )}

                <Button
                  disabled={isLoading || isUploading}
                  variant="contained"
                  size="large"
                  endIcon={
                    <KeyboardDoubleArrowRightIcon
                      sx={{
                        transform:
                          i18n.language === "ar" ? "rotate(180deg)" : "none",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  }
                  sx={{ background: theme.palette.info?.main, gap: 1 }}
                  onClick={handleFinish}
                >
                  {isLoading ? (
                    <CircularProgress size={25} />
                  ) : (
                    t("admissions.finish")
                  )}
                </Button>
              </Grid>

              {
                (countriesLoading || citiesLoading || faculitiesLoading || departmentsLoading || termsLoading)
                && <CircularProgress size={26}
                  thickness={8}
                  sx={{ color: "black" }} />
              }

            </Grid>
          )}
        </Box>
      )}
    </Box>
  );
}
